// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e41e4e49","498":"dbc30fff"}[chunkId] + ".chunk.js";
};